import React, { useState } from 'react';

const AddResourceModal = ({ onClose, onAdd }) => {
  const [newResource, setNewResource] = useState({ type: 'Person', name: '', skills: '' });

  const handleAdd = () => {
    onAdd(newResource);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Add New Resource</h2>
        <select
          value={newResource.type}
          onChange={(e) => setNewResource({ ...newResource, type: e.target.value })}
          className="select w-full mb-4"
        >
          <option value="Person">Person</option>
          <option value="Vehicle">Vehicle</option>
          <option value="Equipment">Equipment</option>
          
        </select>
        <input
          type="text"
          value={newResource.name}
          onChange={(e) => setNewResource({ ...newResource, name: e.target.value })}
          placeholder="Name"
          className="input w-full mb-4"
        />
        {newResource.type === 'Person' && (
          <input
            type="text"
            value={newResource.skills}
            onChange={(e) => setNewResource({ ...newResource, skills: e.target.value })}
            placeholder="Skills (comma separated)"
            className="input w-full mb-4"
          />
        )}
        <div className="flex justify-end space-x-2">
          <button onClick={handleAdd} className="btn btn-blue">Add</button>
          <button onClick={onClose} className="btn btn-gray">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default AddResourceModal;
